import EulaPackages from './EulaPackages.js';

class Institution {
    static deserialize({name, attributePackages, ...data}) {
        var hasEmailAuthentication = data.userAuthenticationMethod === 'username',
            eulaPackages = attributePackages.filter(name => EulaPackages.includes(name)),
            notifications = {
                systemNotification: data.systemNotification,
                institutionNotification: data.institutionNotification
            },
            userSettings = {
                hasEmailAuthentication,
                guestsAllowed: data.anonymousUsersAllowed,
                accountCreationAllowed: data.userAccountCreationAllowed && hasEmailAuthentication
            };

        return new Institution({name, notifications, eulaPackages, userSettings});
    }

    constructor({name, notifications, eulaPackages, userSettings}) {
        this.name = name;
        this.notifications = notifications;
        this.eulaPackages = eulaPackages;
        this.userSettings = userSettings;
    }

    accountCreationAllowed() {
        return this.userSettings.accountCreationAllowed;
    }

    getEulaPackages() {
        return this.eulaPackages;
    }

    getName() {
        return this.name;
    }

    getNotifications() {
        return this.notifications;
    }

    guestsAllowed() {
        return this.userSettings.guestsAllowed;
    }

    hasEmailAuthentication() {
        return this.userSettings.hasEmailAuthentication;
    }
}

export default Institution;